import React, { Component } from "react";

import "./styles/loading.css";

class NoDataAlert extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { text, hasShadow, p = 0, pl = 0, pt = 15, pr = 20, color = "#212529", bg = "#fff", mr = 0, ml = 0 } = this.props;
    return (
      <div className="usersItem" style={{ cursor: 'default' }}>
        <div className={`container ${hasShadow ? 'wrapper' : ""}`} style={{ padding: '15px 20px 0px 20px', background: bg }} >
          <span className="text" style={{ color: '#212529', fontFamily: 'apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,Liberation Sans,sans-serif' }}>{text}</span>
        </div>
      </div>
    );
  }
}

export default NoDataAlert;



// WEBPACK FOOTER //
// ./src/components/noDataAlert.js